import React from "react";
import {
  UseFormRegister,
  FieldValues,
  FieldError,
  Merge,
  FieldErrorsImpl,
} from "react-hook-form";

interface FileInputProps {
  label?: string;
  formFieldClassName?: string;
  name: string;
  register: UseFormRegister<FieldValues>;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  accept?: string;
  multiple?: boolean;
  error?: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>>;
  className?: string;
  required?: boolean;
  required_asterik?: boolean;
  disabled?: boolean;
}

const FormFileInput: React.FC<FileInputProps> = ({
  label,
  formFieldClassName,
  name,
  register,
  size = "xs",
  onChange,
  accept,
  multiple,
  error,
  className,
  required,
  disabled,
  required_asterik,
}) => {
  const { ref, onChange: registerOnChange, ...rest } = register(name);

  return (
    <div
      className={`w-full max-lg:flex-col flex lg:items-center gap-2 ${formFieldClassName}`}
    >
      {label && (
        <label className="block text-[0.6rem] font-medium w-full lg:w-[200px]">
          {required || required_asterik ? (
            <span className="text-error">*</span>
          ) : (
            ""
          )}{" "}
          {label}
        </label>
      )}
      <div className="flex flex-col flex-1 gap-2">
        <input
          type="file"
          required={required}
          disabled={disabled}
          accept={accept}
          multiple={multiple}
          {...rest}
          ref={ref}
          className={`file-input file-input-${size} font-bold text-primary file-input-xs file-input-bordered file-input-primary ${
            error ? "border-error" : ""
          } ${className}`}
          onChange={(e) => {
            registerOnChange(e); // ✅ React Hook Form's onChange
            onChange?.(e); // ✅ Your custom onChange
          }}
        />
        {error && <p className="text-error text-xs mt-1">{error.toString()}</p>}
      </div>
    </div>
  );
};

export default FormFileInput;
